import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldTag'])
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldTag'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldTag'])
    },
}